import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { ErrorMessage, Field } from 'formik';
import get from 'lodash/get';

import SelectField from '../../basic/SelectField';
import PropTypes from 'prop-types';

function FormSelect(props) {
  const {
    indices,
    value,
    values,
    name,
    options,
    defaultValue,
    onChange,
    closeMenuOnSelect,
    isDisabled,
    label,
    onFilterOptions,
    ...rest
  } = props;
  const fieldName = typeof name === 'function' ? name(indices) : name;

  let filteredOptions = options;
  if (onFilterOptions) {
    filteredOptions = options?.filter(opt => onFilterOptions(opt, values));
  }

  return (
    <Box>
      <Field name={fieldName} id={fieldName}>
        {({ form: { setFieldValue } }) => (
          <SelectField
            {...{
              name: fieldName,
              label,
              options: filteredOptions,
              defaultValue,
              onChange: option => {
                setFieldValue(fieldName, option || []);
                if (onChange) {
                  onChange(name, option, setFieldValue);
                }
              },
              closeMenuOnSelect: closeMenuOnSelect || true,
              disabled: isDisabled,
              value: value || {},
              ...rest,
            }}
          />
        )}
      </Field>
      <ErrorMessage name={fieldName}>
        {msg => {
          return <Text color="error">{get(msg, 'value') || msg}</Text>;
        }}
      </ErrorMessage>
    </Box>
  );
}

export default FormSelect;

FormSelect.propTypes = {
  indices: PropTypes.array,
  value: PropTypes.any,
  values: PropTypes.object,
  name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.array,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  closeMenuOnSelect: PropTypes.bool,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  onFilterOptions: PropTypes.func,
};
